// config
import { config } from '@shakkerai/config';

// hash
import { calculateHash } from './hash.js';

// client
import { getOssClient } from './get-oss-client.js';

// bizcodes
import { BIZ_CODES } from './const.js';

/**
 * 上传-生图（bizCode为0）
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForSD = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('0', uuid, file, null, null, onCalcHashEnd);
};

/**
 * 上传-生图（bizCode为0）-tmp
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForSDTmp = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('0', uuid, file, null, 'tmp', onCalcHashEnd);
};

/**
 * 上传-模版工具（bizCode为0）
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForTemplate = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('0', uuid, file, null, null, onCalcHashEnd);
};

/**
 * 上传-专业工具（bizCode为0）
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForPro = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('0', uuid, file, null, null, onCalcHashEnd);
};

/**
 * 上传-训练（bizCode为2）
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForTraining = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('2', uuid, file, null, null, onCalcHashEnd);
};

/**
 * 上传-社区（bizCode为1）-图片
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForCommunityImage = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('1', uuid, file, 'image', null, onCalcHashEnd);
};

/**
 * 上传-社区（bizCode为1）-其他
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @returns
 */
export const singleUploadForCommunityOther = async (uuid, file, onCalcHashEnd) => {
  return await singleUpload('1', uuid, file, 'other', null, onCalcHashEnd);
};

/**
 * singleUpload
 * @param {*} bizCode 0生图，模版工具，专业工具，1社区，2训练
 * @param {*} uuid 用户uuid
 * @param {*} file
 * @param {*} communityType
 * @param {*} isSDTmp
 * @param {*} onCalcHashEnd
 * @returns
 */
async function singleUpload(bizCode, uuid, file, communityType, isSDTmp, onCalcHashEnd) {
  const methodName = 'singleUpload';
  try {
    // log
    console.info(methodName, 'bizCode', bizCode);
    console.info(methodName, 'uuid', uuid);
    console.info(methodName, 'file', file);
    console.info(methodName, 'communityType', communityType);
    console.info(methodName, 'isSDTmp', isSDTmp);

    // check
    if (!bizCode) {
      console.info(methodName, 'need bizCode');
      return;
    }
    if (BIZ_CODES.indexOf(bizCode) === -1) {
      console.info(methodName, '非法的bizCode');
      return;
    }
    if (!uuid) {
      console.info(methodName, 'need uuid');
      return;
    }
    if (!file) {
      console.info(methodName, 'need file');
      return;
    }

    // hash
    const fileHash = await calculateHash(file, onCalcHashEnd);
    console.info(methodName, 'fileHash', fileHash);
    if (!fileHash) return;

    // client
    const client = await getOssClient(bizCode, isSDTmp);
    if (!client) return;

    // filename
    let fileName = file.name;
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    if (fileExtension && fileHash) fileName = fileHash + fileExtension;
    console.info(methodName, 'fileName', fileName);

    // oss path
    let preOssPath;
    if (bizCode === '0') {
      preOssPath = 'img';
    }
    if (bizCode === '1') {
      preOssPath = 'web';
      if (communityType == 'image') preOssPath = 'web/image';
      if (communityType == 'other') preOssPath = 'web';
    }
    if (bizCode === '2') {
      preOssPath = 'train_img';
    }
    const ossPath = `${preOssPath}/${uuid}/${fileName}`;
    console.info(methodName, 'ossPath', ossPath);

    // put
    await client.put(ossPath, file);

    // return
    const url = `${isSDTmp ? config.oss.cdnHostForSDTmp : config.oss.cdnHost}/${ossPath}`;
    return { file: ossPath, url: url };
  } catch (error) {
    console.error(methodName, 'get oss token error');
    console.error(methodName, error);
  }
}
